import CallMadeIcon from '@mui/icons-material/CallMade';
import GroupIcon from '@mui/icons-material/Group';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { Box, Button, Card, CardContent, Typography, useTheme } from '@mui/material';
import { useContext } from 'react';
import { LoginContext } from '../contexts/LoginContext';
import { PackageType } from '../enums/packageTypes';
import styles from '../styles/Home.module.css';

function TestSeriesCard({ title, description, isMargin, isTestSeriesList, actionButtonText, image, bulletPoints, price, onLearnMore, onEnroll, testsCount, duration, testSeriesStudentsCount, studentsCount, isHideStudentIcon, cardDescription, fontSize, TagOnCard, SubjectTagOnCard, FreeCPTag, bestCoupen, isShowIncludeBullet }) {
    console.log(bestCoupen, '-bestCoupen')
    const theme = useTheme();
    const { packageId } = useContext(LoginContext);
    return (
        <Box sx={{ position: 'relative', margin: 2 }}>
            {/* Badge for New Program */}
            {/* <Box
                sx={{
                    position: 'absolute',
                    top: 10,
                    left: 10,
                    backgroundColor: theme.palette.secondary.main,
                    color: '#fff',
                    padding: '5px 10px',
                    borderRadius: '8px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    zIndex: 1,
                }}
            >
                New Program
            </Box> */}
            <Card sx={isMargin === true ? { margin: '35px 5px 5px 5px' } : {}} className={styles.Rectangle8}>
                {SubjectTagOnCard && <Box
                    className={styles.subjectBadge}
                    sx={{
                        position: 'absolute',
                        top: '3.5vh',
                        left: isTestSeriesList ? -8 : 11,
                        transform: 'rotate(-32deg)',
                        zIndex: 1,
                        borderRadius: '32rem 6rem 29rem 0rem',
                        width: '15vh',
                    }}
                >
                    {SubjectTagOnCard}
                </Box>}
                {/* Badge for New Program */}
                {TagOnCard && <Box
                    className={styles.newLaunchBadge}
                    sx={{
                        top: 165,
                        left: isTestSeriesList ? 5 : 25,
                    }}
                >
                    {TagOnCard}
                </Box>}

                <div>
                    {image && <img src={FreeCPTag === true ? '/TS_CPCard7.PNG' : image} alt={title} style={{ width: '100%', height: '200px ' }} />}
                </div>

                {/* <div style={{ position: 'relative' }}>
                    {image && <img src={FreeCPTag === true ? '/TS_CPCard7.PNG' : image} alt={title} style={{ width: '100%', height: '200px ' }} />}
                    {
                        FreeCPTag === true ? null :
                            <Box className={styles.offerBadge}>
                                <span className={styles.line1}>College Predictor worth ₹1000/-</span>
                                <span className={styles.line2}>worth ₹1000/-</span>
                            </Box>
                    }

                </div> */}
                <CardContent style={{ height: '180px', cursor: 'context-menu' }}>
                    <Box>
                        <div className={styles.TestSeriesTitle}>{title?.slice(0, 30)}</div>

                        {/* <Typography variant="body2" color="text.secondary">{description}</Typography> */}

                        {/* Display up to 2 bullet points, with "..." if there are more */}
                        <Typography variant="body2" calssName={styles.cardDescription} style={{ listStyleType: 'disc', fontSize: fontSize ? `${fontSize}px` : '13px', textAlign: 'left', height: '95px', fontFamily: 'Poppins' }}>
                            {/* {FreeCPTag === true && <small className={styles.freeCPTitle}>With College Predictor Worth ₹ 1000</small>} */}
                            {/* {description ? ReactHtmlParser(description?.slice(0, 109)) : "No description available."} */}
                            {cardDescription}

                            {isShowIncludeBullet &&
                                <Box
                                    component="li"
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'flex-start',
                                        listStyle: 'none',
                                        fontSize: fontSize ? `${fontSize}px` : '13px',
                                        fontFamily: 'Poppins',
                                        color: '#ec9706',
                                        fontWeight: 600,
                                    }}
                                >
                                    <Box
                                        component="span"
                                        sx={{
                                            color: '#ec9706',
                                            fontWeight: 700,
                                            fontSize: '16px',
                                            marginRight: '6px',
                                            lineHeight: 1.2,
                                        }}
                                    >
                                        +
                                    </Box>
                                    Includes Previous Year Tests
                                </Box>}
                            {/* {bulletPoints && bulletPoints.slice(0, 2).map((point, index) => (
                            <li key={index} style={{ margin: '10px 0px' }}>{point}</li>
                        ))} */}

                            {/* {bulletPoints.length > 2 && <li>...</li>} // can display "..." if more than 2 points */}
                        </Typography>
                    </Box>
                    {/* <div className={styles.Line9}></div> */}
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px', borderTop: '1px solid #cacaca' }}>
                        {/* <Box sx={{ display: 'flex', flexDirection: 'row' }}> */}
                        <span style={{ visibility: 'hidden' }} className={styles.price}>{isHideStudentIcon ? "" : <GroupIcon className={styles.peoples} />} {testSeriesStudentsCount}</span>
                        {/* <p style={{ margin: '7% 6% 0% 6%', fontSize: '13px', color: theme.palette.sectionHeading.main }}>{duration ?? 0}{` Months`}</p> */}

                        {/* DISCOUNT % */}
                        {bestCoupen > 0 > 0 && (
                            <Box
                                sx={{
                                    margin: '13px 0px 3px 0px',
                                    fontSize: "1.1rem",
                                    fontWeight: 700,
                                    color: "#ec9706",
                                    background: "#ec97062b",
                                    padding: "2px 6px",
                                    borderRadius: "4px",
                                    lineHeight: "1.4rem",
                                }}
                            >
                                {bestCoupen}% OFF
                            </Box>
                        )}
                        {/* ORIGINAL PRICE */}
                        {bestCoupen > 0 && (
                            <Typography
                                sx={{
                                    margin: '13px 0px 3px 0px',
                                    textDecoration: "line-through",
                                    fontSize: "1.3rem",
                                    color: "#52667a",
                                    fontWeight: 500,
                                }}
                            >
                                ₹ {price}
                            </Typography>
                        )}

                        {/* Price on the left side */}
                        <span className={styles.price} style={{ margin: '13px 0px 3px 0px' }}>
                            <LocalOfferIcon className={styles.priceTag} />
                            {/* {`₹ ${price || 0}`} */}
                            {bestCoupen > 0 ?
                                (`₹ ${price - (price * bestCoupen) / 100}`)
                                : (`₹ ${price}`)
                            }
                        </span>
                        {/* Learn More button on the right side */}
                        {/* <Button size="small" onClick={onLearnMore} style={{ float: 'right', marginTop: '10px' }}>Learn More</Button> */}
                    </Box>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '10px' }}>
                        {/* <Box sx={{ display: 'flex', flexDirection: 'row' }}> */}
                        {/* <p style={{ margin: '3% 6% 0% 3%', fontSize: '17px', color: theme.palette.secondary.main }}>{testsCount} Tests</p> */}
                        <Button className={styles.Rectangle24} onClick={onLearnMore} style={{ visibility: isHideStudentIcon ? 'hidden' : '' }}>
                            {/* {`₹ ${price || 0}`} */}
                            Know More
                        </Button>
                        {/* <p style={{ margin: '7% 6% 0% 6%', fontSize: '13px', color: theme.palette.sectionHeading.main }}>{duration ?? 0}{` Months`}</p> */}

                        {/* Price on the left side */}
                        {/* <Typography variant="h6" component="div" style={{ margin: '2% 6%  0% 5%', color: theme.palette.primary.main, fontSize: '20px' }}>
                        {`₹ ${price || 0}`}
                    </Typography> */}

                        {/* Learn More button on the right side */}
                        {/* <Button size="small" onClick={onLearnMore} style={{ float: 'right', marginTop: '10px' }}>Learn More</Button> */}
                        <Button className={styles.Rectangle25} onClick={onEnroll} disabled={packageId && packageId === PackageType.TRIAL}>
                            {/* {`₹ ${price || 0}`} */}
                            {actionButtonText === 'Sign Up' ? actionButtonText : 'Buy Now'}  <CallMadeIcon />
                        </Button>
                    </Box>
                </CardContent >
            </Card >
        </Box >
    );
}

export default TestSeriesCard;
